// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { DiscriminatorCode, DiscriminatorCodeSchema } from 'api/gen/DiscriminatorCode';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { DiscriminatorName, DiscriminatorNameSchema } from 'api/gen/DiscriminatorName';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  code: DiscriminatorCodeSchema,
  id: PositiveIntegerSchema,
  name: t.union([DiscriminatorNameSchema, t.null]),
});

export const AuthDiscriminatorDetailSchema = excess(requiredPart);

export interface AuthDiscriminatorDetail extends t.TypeOf<typeof AuthDiscriminatorDetailSchema> {}
